import * as ActionTypes from './auth.actionTypes';
import filter from 'lodash/filter';
import map from 'lodash/map';
import { config } from '../../acl';

const initialState = {
  isAuthenticated: false,
  isLoading: true,
  authToken: null,
  user: null,
  role: null,
  acl: {},
  roles: [],
  targetings: [],
  tags: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AUTH_INVALIDATE:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        authToken: null,
        user: null,
        role: null,
        acl: null,
        roles: [],
        targetings: [],
        tags: [],
      };
    case ActionTypes.ADMIN_LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: true,
        user: null,
        role: null,
        acl: null,
        roles: [],
        targetings: [],
        tags: [],
      };
    case ActionTypes.LOGIN_REQUEST:
      return {
        ...state,
      };
    case ActionTypes.ADMIN_LOGIN_SUCCESS:
    case ActionTypes.LOGIN_SUCCESS:
      const role = action.response.entities.user[action.response.result.user.id].role;
      const acl = filter(map(config, (item, key) => (item.indexOf(role) > -1 ? key : null)), k => k !== null);
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        authToken: action.response.result.token,
        user: action.response.result.user.id,
        role,
        acl,
        roles: action.response.result.roles,
        targetings: action.response.result.channels,
        tags: action.response.result.tags,
      };
    case ActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        authToken: null,
        user: null,
        role: null,
        acl: null,
        roles: [],
        targetings: [],
        tags: [],
      };
    case ActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
      };
    case ActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        authToken: null,
        user: null,
        role: null,
        acl: null,
        roles: [],
        targetings: [],
        tags: [],
      };
    case ActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/auth/auth.reducer.js